import imgBg from '@assets/images/static/bg-splashscreen.png';
import imageSite from '@assets/images/static/img_asset_menu_ideev.jpg';
import { useLingui } from '@lingui/react';
import { Site, Thematique } from '@zeus/index';
import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useSoundAudio from '~/helpers/hooks/soundAudio';
import useConnectionStore from '~/helpers/store/connection/connection';
import {
  SBtnActionWrapper,
  SDivBlur,
  SDivDialog,
  SDivSelected,
  SPThematique,
  SSpanTitle,
} from '~/pages/components/styles/styles';
import Button from '~/pages/components/ui/button';
import ThematiqueItem from '~/pages/components/ui/thematique-item';
import ThematiqueSelected from '~/pages/components/ui/thematique-selected';
import Layout from '~/pages/layouts/empty';
import { classic } from '~/themes';
import { TThematique } from '~/utils/airtable/types/types';
import { getThematiquesBySite } from '~/utils/airtable/utils';
import { renderFullPath } from '~/utils/common/utils';
import { useConnection } from '../../helpers/hooks/connection';

function Ideev() {
  const [thematiques, setThematiques] = useState<TThematique[]>([]);
  const { setCurrentSite } = useConnectionStore();
  const { i18n } = useLingui();
  const [selectedThematique, setSelectedTematique] =
    useState<Thematique | null>(null);
  const { playSound } = useSoundAudio();
  const [offset, setOffset] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);
  const [canGoToThematique, setCanGoToTematique] = useState<
    string | undefined
  >();

  const navigate = useNavigate();

  useConnection();

  useEffect(() => {
    setCurrentSite(Site.IDEEV);
    setThematiques(getThematiquesBySite());
  }, []);

  function handleClick(thematique: string) {
    playSound('valid');
    setCanGoToTematique(thematique);
    //navigate(`/thematique/ideev/${thematique}`);
  }

  function handleChoiseThematique(thematique: Thematique, index: number) {
    playSound('click');
    setSelectedTematique(thematique);

    if (sliderRef.current) {
      const sliderWidth = sliderRef.current.offsetWidth;
      const imageWidth = sliderWidth / 5.2;
      const newOffset = imageWidth * index;

      setOffset(newOffset);
    }
  }

  return (
    <Layout $background={imgBg} $menuWithLogo>
      <Container>
        <SDivTitle>
          <Link to={'/'} onClick={() => playSound('click')}>
            <SSpanTitle $textDecoration="underline">
              {i18n._('home.title')}
            </SSpanTitle>
          </Link>

          <SSpanTitle
            $margin="0 5px 0 5px"
            $color={`${classic.token?.colorPrimary}`}
          >
            {' / '}
          </SSpanTitle>
          <SSpanTitle $color={`${classic.token?.colorPrimary}`}>
            {i18n._('site.ideev.title')}
          </SSpanTitle>
        </SDivTitle>
        <SDivSiteImg $background={imageSite} />
        <SDivBtnWrapper>
          <SDivSliderContainer ref={sliderRef}>
            <SDivThematiques
              className="slider"
              style={{ transform: `translateX(-${offset}px)` }}
            >
              {thematiques.map((el, index) => (
                <ThematiqueItem
                  key={index}
                  onClick={() =>
                    handleChoiseThematique(el.thematique as Thematique, index)
                  }
                  selected={selectedThematique === el.thematique}
                  name={el.name}
                  pnjName={el.characterName}
                  pnjImageSrc={renderFullPath(el.characterImg)}
                />
              ))}
            </SDivThematiques>
          </SDivSliderContainer>
          <Button
            hidden={selectedThematique === null}
            color="secondary"
            onClick={() =>
              selectedThematique && handleClick(selectedThematique)
            }
          >
            {i18n._('action.site.go')}
          </Button>
        </SDivBtnWrapper>
        <SDivBlur hidden={canGoToThematique === undefined}>
          <SDivDialog className={canGoToThematique !== undefined ? 'open' : ''}>
            <SPThematique $fontWeight="700" $color="#009fc3">
              {i18n._('action.thematique.confirm.text')}
            </SPThematique>
            <SDivSelected>
              <ThematiqueSelected
                name={
                  thematiques.find((el) => el.thematique === selectedThematique)
                    ?.name ?? ''
                }
                pnjName={
                  thematiques.find((el) => el.thematique === selectedThematique)
                    ?.characterName ?? ''
                }
                pnjImageSrc={renderFullPath(
                  thematiques.find((el) => el.thematique === selectedThematique)
                    ?.characterImg ?? ''
                )}
              />
            </SDivSelected>
            <SBtnActionWrapper>
              <Button
                minWidth="90%"
                color={'primary'}
                onClick={() => {
                  playSound('valid');
                  navigate(`/thematique/ideev/${selectedThematique}`);
                }}
                margin="0 0 10px 0"
              >
                {i18n._('actions.start')}
              </Button>
              <Button
                color={'transparent'}
                minWidth="90%"
                textColor={`${classic.token?.colorText}`}
                onClick={() => {
                  playSound('click');
                  setCanGoToTematique(undefined);
                }}
              >
                {i18n._('actions.cancel')}
              </Button>
            </SBtnActionWrapper>
          </SDivDialog>
        </SDivBlur>
      </Container>
    </Layout>
  );
}

export default Ideev;

const Container = styled.div<{ $background?: string }>`
  align-items: center;
  background-color: #bdd8dd;
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

const SDivSiteImg = styled.div<{ $background?: string }>`
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  flex-grow: 1;
  width: 100%;
`;

const SDivTitle = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 20%;
  justify-content: center;
  width: 100%;
`;

const SDivBtnWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 33%;
  padding-bottom: 15px;
  width: 100%;
  @media screen and (max-width: 415px) {
    flex: 0 0 34%;
  }
  @media screen and (max-height: 600px) {
    flex: 0 0 34%;
  }
`;

const SDivThematiques = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  height: auto;
  transition: transform 0.5s ease;
  width: 100%;
`;

const SDivSliderContainer = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
`;
